module.exports = __webpack_public_path__ + "img/vwid2-fr.8c796125.webp";